import Plugin from "../core/plugins";

import { SystemPromptPlugin } from "./system-prompt";
import { TitlePlugin } from "./titles";
import { ContextTrimmerPlugin } from "./trimmer";

export const registeredPlugins: Array<typeof Plugin<any>> = [
    SystemPromptPlugin,
    ContextTrimmerPlugin,
    TitlePlugin,
];